/**
 * List of our core values with icons and rotating details.
 */
export default class CoreValues {

    /** @type {HTMLElement} */
    _element

    /** @type {NodeListOf<HTMLLIElement>} */
    _items

    /** @type {HTMLLIElement} */
    _active

    _timeoutId

    /**
     * Hydrate a server rendered CoreValues component.
     * @param {HTMLElement} element A DOM element to hydrate with the required structure
     */
    hydrate(element) {
        if (!element) throw Error('Element is ' + element + '.')

        this._element = element
        this._items = element.querySelectorAll('li')

        if (!this._items) {
            throw Error('The HTML to hydrate has an invalid structure.')
        }

        this._showItem(0)
        this._setupClickHandler()
    }

    /**
     * Show an item.
     * @param {number} key Key of the list item to show
     */
    _showItem(key) {
        if (this._active) {
            this._active.classList.remove('active')
        }

        if (!key || key >= this._items.length) {
            key = 0
        }

        this._active = this._items[key]
        this._active.classList.add('active')

        this._timeoutId = setTimeout(() => this._showItem(key + 1), 12000)
    }

    /**
     * Set up click handler to manually change between items.
     */
    _setupClickHandler() {
        if (typeof this._items.forEach !== 'function') return

        this._items.forEach((item, key) => {
            const header = item.querySelector('header')
            header.addEventListener('click', e => {
                clearTimeout(this._timeoutId)
                this._showItem(key)
            })
        })
    }

}
